export default __webpack_public_path__ + "static/trance02-6f0d56dd6cc8a339615c18958f10c44c.webp";